import fp from 'lodash/fp'
import mapper from 'utils/simple-mapper'

const mapping = [
  ['event', 'eventId', fp.get('id')],
  // ['tournamentId', 'tournamentId', fp.get('id')],
  ['athleteId', 'athleteId', fp.get('id')],
  // ['score'],
  ['outcome'],
  ['description'],
  ['condition', 'triggerCondition', fp.get('id')],
  ['binaryWinner', 'binaryWinner', fp.get('id')],
  ['category', 'category', fp.get('id')],
  ['subCategory', 'subCategory', fp.get('id')],
]

export const toTriggerModel = (formModel) => {
  // Get the mapped data
  const mapped = mapper(formModel, mapping);

  // Ensure we have the minimal required fields
  if (!mapped.eventId) {
    console.error('Event ID is required');
  }

  if (!mapped.category) {
    console.error('Category is required');
  }

  if (!mapped.subCategory) {
    console.error('SubCategory is required');
  }

  return mapped;
}
